import { gql } from "apollo-boost";

export const EMAIL_EXIST = gql`
  query EmailExist($email: String!) {
    emailExist(email: $email) {
      exist
    }
  }
`;

export const SEND_VERIFICATION_CODE = gql`
  mutation SendVerificationCode($verificationSendTo: String!, $verificationChannel: String!) {
    sendVerificationCode(verificationSendTo: $verificationSendTo, verificationChannel: $verificationChannel) {
      status
      message
    }
  }
`;

export const CHECK_VERIFICATION_CODE_AND_UPDATE_EMAIL = gql`
  mutation CheckVerificationCodeAndUpdateEmail($verificationSendTo: String!, $code: String!) {
    selfServiceUpdateEmailWithVerification(verificationSendTo: $verificationSendTo, code: $code) {
      status
      userToken
    }
  }
`;